import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import RepositoryPicker from '../../../containers/RepositoryPicker/RepositoryPicker';
import DateRangePicker from '../../../containers/DateRangePicker';
export const Controls = ({ repositoriesList, activeRepositoriesIds, repos, repositoriesSlugs, from, to, handleChangeRepositories, handleChangeDateRange }) => {
    const values = activeRepositoriesIds.map((id) => ({
        value: id,
        label: repos[repositoriesSlugs[id]].fullname,
    }));
    return _jsxs("div", { className: "velocity__row mt-0 pt-4", children: [_jsx(RepositoryPicker, { className: "col-12 col-md-6 col-lg-5 col-xl-4", onChange: handleChangeRepositories, options: repositoriesList, values: values }), _jsx("span", { className: "velocity__divider d-none d-md-block" }), _jsx(DateRangePicker, { className: "col-12 col-md-5 col-lg-4 col-xl-3", from: from, onChangeDates: handleChangeDateRange, to: to })] });
};
